export class MongoAtlasClusterResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusterTier",
            "baseName": "clusterTier",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterType",
            "baseName": "clusterType",
            "type": "string",
            "format": ""
        },
        {
            "name": "mongoVersion",
            "baseName": "mongoVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "storageIops",
            "baseName": "storageIops",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "string",
            "format": ""
        },
        {
            "name": "atlasRegionName",
            "baseName": "atlasRegionName",
            "type": "string",
            "format": ""
        },
        {
            "name": "placements",
            "baseName": "placements",
            "type": "Array<MongoAtlasRegionPlacement>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasClusterResource.attributeTypeMap;
    }
    constructor() {
    }
}
